import { render } from "./event-task.vue?vue&type=template&id=4cdbbe17&lang=pug"
import script from "./event-task.vue?vue&type=script&lang=js"
export * from "./event-task.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__